// FILE: sideChat.ts
// Purpose: The single reading of what makes a thread a side chat, shared by the
//          web (which opens and paints it) and the server (which must keep it
//          out of the delegation machinery).
// Layer: shared runtime utility
// Depends on: nothing

/**
 * Role a thread carries when it was opened as a side chat over a fragment of
 * another thread's transcript.
 *
 * It sits beside `DELEGATED_SUBAGENT_ROLE` rather than reusing it, and the
 * distinction is load-bearing on both sides: the delegation tools count, poll
 * and close *their* children, and a side chat is none of their business — it
 * belongs to the user who opened it, not to the parent agent. Lives in shared
 * because the two sides have to agree on the exact string: the web stamps it on
 * `thread.create` and the server reads it to decide what a child is.
 */
export const SIDE_CHAT_THREAD_ROLE = "side-chat";

/**
 * Whether a thread was opened as a side chat.
 *
 * Structural and unbranded for the same reason `DelegationThreadView` is: the
 * server holds `OrchestrationThread` with `null` for the absence and the web
 * holds its own summaries with `undefined`, and both have to be assignable.
 */
export function isSideChatThread(thread: {
  readonly subagentRole?: string | null | undefined;
}): boolean {
  return thread.subagentRole === SIDE_CHAT_THREAD_ROLE;
}
